<div class="main-overlay" *ngIf="isProcessing">
  <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
</div>
<router-outlet></router-outlet>
